import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/ResetPassword.css';
import loginImg from "../../assets/loginImage.jpeg";
import Navbar from '../../layouts/Navbar';
import logo from "../../assets/Logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import axios from 'axios';
import { Link } from 'react-router-dom';

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password || !confirmPassword) {
      setErrorMessage("Please enter both password fields");
      return;
    }
    try {
      const email = localStorage.getItem("email");
      const otp = localStorage.getItem("otp");

      if (password !== confirmPassword) {
        setErrorMessage("Passwords do not match");
        return;
      }

      const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
      if (!passwordRegex.test(password)) {
        toast.error("Password must be at least 8 characters long and contain both letters and numbers");
        return;
      }

      const response = await axios.post("https://yelospace.com/api/reset-pass/user", { email, otp, password });
     
      if (response.data.status === 200) {
        toast.success("Password Reset Successfully");
        setTimeout(() => {
          navigate('/login');
          localStorage.clear();
        }, 2500); // 2-second delay before navigating to login
      } else {
        toast.error('Failed to reset password');
      }
    } catch (error) {
      console.error('Error occurred:', error);
    }
  };

  return (
    <>
      {/* <Navbar/> */}
      <ToastContainer />
      <div className="reset-password-container">
        <div className="w-100 d-flex justify-content-center">
          <div className="left-panel">
            <img src={loginImg} alt="Left Panel Image" />
          </div>
          <div className="right">
            <div className="w-100 d-flex justify-content-center">
              <Link to="/">
                <img src={logo} className="logo-img" alt="Left Panel Image" />
              </Link>
            </div>
            <div className="reset-password-heading">
              <div className="w-100 d-flex justify-content-center mt-4">
                <h2>Reset Password</h2>
              </div>
            </div>
            <form onSubmit={handleSubmit}>
              <div className='w-100'>
                <div className="password-input-container">
                  <input className='form-control w-100 mx-auto mt-3 p-2 px-4' type={showPassword ? "text" : "password"} id="password" placeholder="New Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                  <span className="password-toggle-btn" onClick={togglePasswordVisibility}>
                    {showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                  </span>
                </div>
              </div>
              <div>
                <div className="password-input-container">
                  <input className='form-control w-100 mx-auto mt-3 p-2 px-4' type={showPassword ? "text" : "password"} id="confirmPassword" placeholder="Confirm Password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                  <span className="password-toggle-btn" onClick={togglePasswordVisibility}>
                    {showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                  </span>
                </div>
              </div>
              {errorMessage && <div className="error">{errorMessage}</div>}
              <div className="d-flex justify-content-center w-100">
                <button type="submit" className="submit-btn mt-3">Reset Password</button>
              </div>
            </form>
            <div className="w-100 d-flex justify-content-center">
              <div className="back-to-login">
                <a href="/login">Back to <span style={{textDecoration: "underline"}}>Login </span> </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
